import { ScanSummaryModalFormValues } from '../NgzScanSummaryModal.settings';
import { SuggestionScenariosInfo } from '../../../interfaces/suggestionScenariosInfo';

export const getFormDefaultValues = (
  scanSummary: SuggestionScenariosInfo,
): ScanSummaryModalFormValues => {
  return {
    inbodyType: scanSummary.inbodyType,
    startScanId: scanSummary.startScanId || null,
    endScanId: scanSummary.endScanId || null,
  };
};
